// utils/pagination.ts
export interface PaginationResult<T> {
  paginatedData: T[];
  totalPages: number;
}

export const ITEMS_PER_PAGE = 10 ;

export function paginate<T>(
  data: T[],
  currentPage: number,
  itemsPerPage: number = ITEMS_PER_PAGE
): PaginationResult<T> {
  const totalItems = data.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const paginatedData = data.slice(startIndex, endIndex);

  return { paginatedData, totalPages };
}

